import { Navigate, Outlet, useLocation } from 'react-router-dom'

import {
  selectAuthLoading,
  selectIsAuthenticated,
  useAppSelector,
} from '@/store'

function AuthRouteHandler() {
  const location = useLocation()
  const isAuthenticated = useAppSelector(selectIsAuthenticated)
  const isLoading = useAppSelector(selectAuthLoading)

  // Always allow login and unauthorized pages
  if (location.pathname === '/login' || location.pathname === '/unauthorized') {
    return <Outlet />
  }

  if (!isAuthenticated && !isLoading) {
    return <Navigate to="/login" replace />
  }

  // Allow rendering for authenticated users or during loading
  return <Outlet />
}

export function AuthWrapper() {
  // No providers needed - Redux handles all state
  return <AuthRouteHandler />
}
